import { sessaoFetchLoading, appFetch } from '@/service/fetch'
import { serialize } from '@/service/util'

export async function get (id) {
  return sessaoFetchLoading(`base`, `/empresa/${id}`)
}
export async function getEmpresas (dados) {
  return sessaoFetchLoading(`base`, `/empresa?` + serialize(dados), 'GET')
}
export async function getEmpresasSelect (dados) {
  return sessaoFetchLoading(`base`, `/empresa?all=1&` + serialize(dados))
}
export async function getEmpresasSelectUsuario (dados) {
  return sessaoFetchLoading(`base`, `/empresa/listarparausuario?` + serialize(dados))
}
export async function add (dados) {
  return sessaoFetchLoading(`consig`, `/Empresas/PostJSEnvelopado`, 'POST', dados)
}
export async function edit (dados) {
  return sessaoFetchLoading('consig', '/empresas/PutEnvelopado', 'PUT', dados)
}
export async function delEmpresa (dados) {
  return sessaoFetchLoading(`base`, `/empresa/${dados}`, 'DELETE')
}
export async function editStatus (dados) {
  return sessaoFetchLoading('consig', '/Empresas/AlteraStatus', 'PUT', dados)
}
export async function getEmpresaLogin (empresa) {
  return appFetch(`base`, `/empresa/login?` + serialize({nome: empresa}))
}
export async function getEmpresasRelatorioSelect (dados) {
  return sessaoFetchLoading(`base`, `/empresarelatorio?all=1&` + serialize(dados))
}



// WEBPACK FOOTER //
// ./src/api/empresa.js